__turbopack_context__.v({
  "carousel": "DailyCarousel-module-sass-module__ppxr2W__carousel",
  "root": "DailyCarousel-module-sass-module__ppxr2W__root",
});
